import React from "react";
import Info from "../../../ui/widgets/info";
import { useMessageSource } from "react-message-source";
import InsurancePlusInfo from "./info";

export default function Included(): React.JSX.Element {
  const { getMessage } = useMessageSource();
  return (
    <>
      <Info title={getMessage("InsurancePlus.Info.title")}>
        {getMessage("InsurancePlusIncluded.Info.text")}
      </Info>
      <InsurancePlusInfo />
    </>
  );
}
